/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';

import { ReactComponent as ByMonthIcon } from '../../assets/by-month.svg';
import { ReactComponent as ByWeekIcon } from '../../assets/by-week.svg';
import { ReactComponent as ByDayIcon } from '../../assets/by-day.svg';
import { ReactComponent as WorkersIcon } from '../../assets/workers.svg';
import { ReactComponent as SpecialityIcon } from '../../assets/speciality.svg';
import { ReactComponent as PinIcon } from '../../assets/pin.svg';
import { TYPES_VIEW } from '../../constans/types-view';
import {
    switchTypeAction,
    switchFilialAction,
    switchSpecialityAction,
    switchDoctorAction
} from './actions';
import { getScheduleAction } from '../schedule/actions';
import { setScheduleInterval } from '../../helpers';
import './style.scss';

const Menu = props => (
    <>
        <components.Menu {...props} className="ReactSelectMenuAnimate">{props.children}</components.Menu>
    </>
);

const ReactSelect = ({
    IconComponent, placeholder, name, ...props
}) => {
    const [menuIsOpen, changeMenuIsOpen] = useState(false);
    const ref = React.createRef();

    return (
        <>
            <div className="tooltip" ref={ref}>
                {placeholder}
            </div>
            <button
                type="button"
                className="schedule__filter_icon"
                onClick={() => changeMenuIsOpen(!menuIsOpen)}
                onBlur={() => {
                    const menuEl = document.querySelector(`#${props.id} .ReactSelectMenuAnimate`);
                    const containerEl = menuEl ? menuEl.parentElement : null;
                    const clonedMenuEl = menuEl ? menuEl.cloneNode(true) : null;

                    if (!clonedMenuEl) return;

                    clonedMenuEl.classList.add('ReactSelectMenuAnimate--close');
                    clonedMenuEl.addEventListener('animationend', () => {
                        containerEl.removeChild(clonedMenuEl);
                    });

                    containerEl.appendChild(clonedMenuEl);
                    changeMenuIsOpen(!menuIsOpen);
                }}
                onMouseOver={() => {
                    ref.current.classList.add('show');
                }}
                onMouseLeave={() => {
                    ref.current.classList.remove('show');
                }}
            >
                <IconComponent />
            </button>
            <Select
                {...props}
                components={{ Menu }}
                classNamePrefix="select-input"
                isSearchable={false}
                menuIsOpen={menuIsOpen}
                onChange={(value, actionMeta) => {
                    const menuEl = document.querySelector(`#${props.id} .ReactSelectMenuAnimate`);
                    const containerEl = menuEl ? menuEl.parentElement : null;
                    const clonedMenuEl = menuEl ? menuEl.cloneNode(true) : null;

                    if (!clonedMenuEl) return;

                    clonedMenuEl.classList.add('ReactSelectMenuAnimate--close');
                    clonedMenuEl.addEventListener('animationend', () => {
                        containerEl.removeChild(clonedMenuEl);
                    });

                    containerEl.appendChild(clonedMenuEl);
                    changeMenuIsOpen(!menuIsOpen);
                    props.onChange(value, actionMeta);
                }}
            />
        </>
    );
};

const ReactSelectWithStore = connect()(ReactSelect);

ReactSelect.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    IconComponent: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired
};

class Filter extends React.Component {
    componentDidUpdate(prevProps) {
        const { schedule: prevSchedule } = prevProps;
        const { schedule, dispatch } = this.props;
        const { workers: prevWorkers } = prevSchedule;
        const { workers } = schedule;

        if (prevWorkers === null && workers) {
            const { search, hash } = window.location;
            if (search !== '') {
                const clearHash = hash.replace('#', '');
                const hashParams = clearHash !== '' ? new URLSearchParams(clearHash) : null;

                if (hashParams && hashParams.get('doctor')) {
                    let worker = workers.filter(item => +item.id === +hashParams.get('doctor'))[0];
                    worker = {
                        label: `${worker.last_name} ${worker.first_name}`,
                        value: worker.id
                    };
                    dispatch(switchDoctorAction(worker));
                }
            }
        }
    }

    switchType = (type) => {
        const { dispatch, filter } = this.props;
        dispatch(switchTypeAction(type));
        dispatch(getScheduleAction({ ...filter, typeView: type }));
        setScheduleInterval({ ...filter, typeView: type }, dispatch);
    };

    switchFilial = (filial) => {
        const { dispatch, filter } = this.props;
        // const typeView = filter.typeView.value === 'month' ? TYPES_VIEW[0] : filter.typeView;
        dispatch(getScheduleAction({ ...filter, filial }));
        dispatch(switchFilialAction(filial));
        setScheduleInterval({ ...filter, filial }, dispatch);
        // dispatch(switchTypeAction(typeView));
    };

    switchSpeciality = (speciality) => {
        const { dispatch, filter } = this.props;
        // const typeView = filter.typeView.value === 'month' ? TYPES_VIEW[0] : filter.typeView;
        dispatch(getScheduleAction({ ...filter, speciality }));
        dispatch(switchSpecialityAction(speciality));
        setScheduleInterval({ ...filter, speciality }, dispatch);
        // dispatch(switchTypeAction(typeView));
    };

    switchWorker = (worker) => {
        const { dispatch, filter } = this.props;
        // const typeView = TYPES_VIEW[1];
        dispatch(getScheduleAction({ ...filter, doctor: worker }));
        dispatch(switchDoctorAction(worker));
        setScheduleInterval({ ...filter, doctor: worker }, dispatch);
        // dispatch(switchTypeAction(typeView));
    };

    setIconTypeView = () => {
        const { filter } = this.props;

        switch (filter.typeView.value) {
            case 'day':
                return <ByDayIcon />;
            case 'week':
                return <ByWeekIcon />;
            case 'month':
                return <ByMonthIcon />;
            default:
                return <ByMonthIcon />;
        }
    };

    render() {
        const {
            filter,
            module,
            schedule
        } = this.props;
        const { filials, services, workers } = schedule;
        let currentSpeciality = filter.speciality;

        if (services && currentSpeciality) {
            currentSpeciality = +currentSpeciality.value ? services.filter(item => +item.id === +currentSpeciality.value) : [{ label: 'Все специальности', value: 0 }];
            currentSpeciality = { label: currentSpeciality[0].name, value: +currentSpeciality[0].id };
        }

        return (
            <div className="schedule__filter">
                {module === null || (module && module.name !== 'specialists') ? (
                    <div className="schedule__filter_item">
                        <ReactSelectWithStore
                            id="ReactSelect-typeView"
                            name="filter-typeView"
                            onChange={option => this.switchType(option)}
                            value={filter.typeView}
                            options={TYPES_VIEW}
                            placeholder="Тип отображения"
                            IconComponent={this.setIconTypeView}
                        />
                    </div>
                ) : null}
                {filter.showFilter ? (
                    <div className="schedule__filter_item">
                        <ReactSelectWithStore
                            id="ReactSelect-filial"
                            name="filter-filial"
                            onChange={option => this.switchFilial(option)}
                            value={filter.filial}
                            options={filials ? [{ label: 'Все филиалы', value: 0 }, ...filials.map(item => ({ label: item.name, value: item.id }))] : [{ label: 'Все филиалы', value: 0 }]}
                            placeholder="Филиал"
                            IconComponent={PinIcon}
                        />
                    </div>
                ) : null}
                {filter.showFilter ? (
                    <div className="schedule__filter_item">
                        <ReactSelectWithStore
                            id="ReactSelect-services"
                            name="filter-services"
                            onChange={option => this.switchSpeciality(option)}
                            value={currentSpeciality}
                            options={services ? [{ label: 'Все специальности', value: 0 }, ...services.map(item => ({ label: item.name, value: item.id }))] : [{ label: 'Все специальности', value: 0 }]}
                            placeholder="Специальность"
                            IconComponent={SpecialityIcon}
                        />
                    </div>
                ) : null}
                {filter.showFilter ? (
                    <div className="schedule__filter_item">
                        <ReactSelectWithStore
                            id="ReactSelect-workers"
                            name="filter-workers"
                            onChange={option => this.switchWorker(option)}
                            value={filter.doctor}
                            options={workers ? [{ label: 'Все врачи', value: 0 }, ...workers.map(item => ({
                                label: `${item.last_name} ${item.first_name}`,
                                value: item.id
                            }))] : [{ label: 'Все врачи', value: 0 }]}
                            placeholder="Специалист"
                            IconComponent={WorkersIcon}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}

Filter.propTypes = {
    dispatch: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    schedule: PropTypes.object.isRequired,
    module: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    filter: state.filter,
    module: state.module,
    schedule: state.schedule
});

export default connect(mapStateToProps)(Filter);
